(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["polocom-collections-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('polocom-collection-carousel')) {
    customElements.define('polocom-collection-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.pc-collections__track');
        this.controls = this.querySelector('.pc-collections__controls');
        this.previous = this.querySelector('[data-direction="previous"]');
        this.next = this.querySelector('[data-direction="next"]');
        if (!this.track) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }
      move(direction) {
        const card = this.track.querySelector('.pc-collections__slide');
        if (!card) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * rtl * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      update() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = maximum <= 2;
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= maximum - 2;
      }
      disconnectedCallback() { this.events?.abort(); this.resize?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["polocom-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('polocom-recommendations')) {
    customElements.define('polocom-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded || this.dataset.performed === 'true') return;
        this.dataset.loaded = 'true';
        this.controller = new AbortController();
        fetch(this.dataset.url, { signal: this.controller.signal })
          .then(response => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
          .then(html => {
            const result = new DOMParser().parseFromString(html, 'text/html').querySelector('polocom-recommendations');
            if (result && result.querySelector('.pc-recommendation')) {
              this.innerHTML = result.innerHTML;
              this.hidden = false;
            }
          })
          .catch(() => {});
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["polocom-track-detect"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle',function(event){if(event.target.matches?.('.ptd-film')&&!event.target.open){event.target.querySelector('video')?.pause();}},true);

  } catch(e) { console.error(e); }
})();
})();
